import React, { useEffect, useState } from "react";
import Layout from "../../layout/Layout";
import TeacherAllDetails from "../../components/teacherAllDetails/teacherAllDetails";
import AdminGrid from "../../components/adminGrid/adminGrid";
import { Rating } from "react-simple-star-rating";
import deleteIcon from "../../assets/images/delete-icon.png";
import actionBtn from "../../assets/images/actionbtn.png";
import { Button, Popover } from "antd";
import { ImWarning } from "react-icons/im";
import { ImBlocked } from "react-icons/im";
import { FaCheck } from "react-icons/fa6";
import WarningModal from "../../components/warningModal/warningModal";
import styles from "./style.module.css";
import "./style.css";
import {
  getTeachers,
  getTeacherDetails,
  teacherReviews,
} from "../../services/auth";
import { toggleBlockTeacher, approvedTeacher } from "../../services/auth";
import { useLocation, useNavigate } from "react-router-dom";
import { baseUrl } from "../../services/api";
import userIcon from "../../assets/images/user-icon-removebg.png";
import toast, { Toaster } from "react-hot-toast";
import BlockedModal from "../../components/blockedModal/blockedModal";
import ReviewsModal from "../../components/reviewsModal/reviewsModal";
import ApprovedModal from "../../components/approvedModal/approvedModal";
import { AiOutlineSearch } from "react-icons/ai";
import { Chip } from "@mui/material";
import LocationModal from "./location-modal";

function TotalTeachers() {
  const [isWarningModalVisible, setIsWarningModalVisible] = useState(false);
  const [isBlockedModalVisible, setIsBlockedModalVisible] = useState(false);
  const [isApprovedModalVisible, setIsApprovedModalVisible] = useState(false);
  const [isReviewsModalVisible, setIsReviewsModalVisible] = useState(false);
  const [cardData, setCardData] = useState({});
  const [data, setData] = useState();
  const [showDetailedCard, setShowDetailedCard] = useState(false);
  const [loading, setLoading] = useState(false);
  const [reviews, setReviews] = useState([]);
  const [input, setInput] = useState("");
  const [blockedMessage, setBlockedMessage] = useState("");

  const [locationModal, setLocationModal] = useState(false);
  const [teacherLocation, setTeacherLocation] = useState();

  const warningModal = (data) => {
    setData(data);
    setIsWarningModalVisible(true);
  };

  const blockedModal = (data) => {
    setData(data);
    setIsBlockedModalVisible(true);
  };

  const approvedModal = (data) => {
    setData(data);
    setIsApprovedModalVisible(true);
  };

  const viewCellRenderer = ({ value, data }) => (
    <div className="d-flex justify-content-between align-items-center gap-2">
      <Button
        size="small"
        className="btn_contained fs_12 px-2 text-white"
        onClick={() =>
          window.open(
            `https://tutify.online/teacherProfile/${data?.uuid}`,
            "_blank"
          )
        }
      >
        Details
      </Button>
      <Button
        size="small"
        className="btn_contained fs_12 px-2 text-white"
        disabled={!data?.locationCoordinates}
        onClick={() => {
          setTeacherLocation(data?.locationCoordinates);
          setLocationModal(true);
        }}
      >
        Location
      </Button>
    </div>
  );

  const actionCellRendererPending = ({ data }) => (
    <Popover content={popoverContentPending(data)} trigger="hover">
      <img
        src={actionBtn}
        alt="Warning / Blocked"
        style={{ width: "30px", height: "17px", cursor: "pointer" }}
      />
    </Popover>
  );

  const actionCellRendererApproved = ({ data }) => (
    <Popover content={popoverContentApproved(data)} trigger="hover">
      <img
        src={actionBtn}
        alt="Warning / Blocked"
        style={{ width: "30px", height: "17px", cursor: "pointer" }}
      />
    </Popover>
  );

  const popoverContentPending = (data) => (
    <div className="text-center">
      {/*   
      <Button
        className="btn btn-sm text-secondary fs_12 border-0"
        onClick={() => {
          console.log("Warning clicked");
          warningModal(data);
          console.log("Warning data", data);
        }}
      >
        <div className="d-flex justify-content-between">
          <div className="mr-1">
            <ImWarning className={`text-secondary ${styles.cicon}`} />
          </div>
          <div>Warning</div>
        </div>
      </Button>
      <br /> */}
      <Button
        className="btn btn-sm text-danger fs_12 border-0"
        onClick={() => {
          blockedModal(data);
          // blockTeacher(data.id, data.isBlocked);
          console.log("Blocked clicked", data);
        }}
      >
        <div className="d-flex justify-content-between">
          <div className="mr-1">
            <ImBlocked className={`text-danger ${styles.cicon}`} />
          </div>
          <div>{data.isBlocked ? "Unblock" : "Block"}</div>
        </div>
      </Button>
      <br />
      <Button
        className="btn btn-sm text-danger fs_12 border-0"
        onClick={() => {
          approvedModal(data);
          // approveTeacher(data.id, data.isApproved);
          console.log("Approved Click", data);
        }}
      >
        <div className="d-flex justify-content-between">
          <div className="mr-1">
            <FaCheck className={`text-secondary ${styles.cicon}`} />
          </div>
          <div className="text-secondary">
            {data.approved ? "Unapproved" : "Approve"}
          </div>
        </div>
      </Button>
    </div>
  );

  const popoverContentApproved = (data) => (
    <div className="text-center">
      <Button
        className="btn btn-sm text-secondary fs_12 border-0"
        onClick={() => {
          console.log("Warning clicked");
          warningModal(data);
          console.log("Warning data", data);
        }}
      >
        <div className="d-flex justify-content-between">
          <div className="mr-1">
            <ImWarning className={`text-secondary ${styles.cicon}`} />
          </div>
          <div>Warning</div>
        </div>
      </Button>
      <br />
      <Button
        className="btn btn-sm text-danger fs_12 border-0"
        onClick={() => {
          blockedModal(data);
          // blockTeacher(data.id, data.isBlocked);
          console.log("Blocked clicked", data);
        }}
      >
        <div className="d-flex justify-content-between">
          <div className="mr-1">
            <ImBlocked className={`text-danger ${styles.cicon}`} />
          </div>
          {/* Check if teacher is blocked or not and set button text accordingly */}
          <div>{data.isBlocked ? "Unblock" : "Block"}</div>
        </div>
      </Button>
    </div>
  );

  // const TeacherReviews = ({ data }) => {
  //   return (
  //     <div className="d-flex align-items-center">
  //       <Rating
  //         size={20}
  //         readonly={true}
  //         initialValue={data?.rating || 0}
  //         style={{ marginRight: "3px", marginTop: "-4px" }}
  //       />
  //       <span style={{ fontSize: "11px" }}>({data?.count})</span>
  //     </div>
  //   );
  // };

  const fetchTeacherReviews = async (id) => {
    try {
      const response = await teacherReviews(id);
      console.log("API response:", response); // Log response for debugging
      return response.data; // Ensure this returns the data in the correct format
    } catch (error) {
      console.error("Error fetching teacher reviews:", error);
      throw error;
    }
  };

  const handleClick = async (id) => {
    try {
      // console.log("Clicked Teacher ID:", id);
      const response = await fetchTeacherReviews(id);
      //console.log("Fetched reviews data:", response); // Log data for debugging
      setReviews(response?.data); // Ensure you set the data correctly
      setIsReviewsModalVisible(true);
    } catch (error) {
      console.error("Error fetching reviews:", error);
    }
  };

  const reviewCellRenderer = (params) => {
    const { rating, ratingCount, id } = params.data;
    // console.log("Teacher ID:", id);
    return (
      <div
        style={{ cursor: "pointer" }}
        onClick={() => handleClick(id)}
        className="d-flex"
      >
        <Rating
          size={20}
          initialValue={rating || 0}
          readonly={true}
          style={{ marginRight: "3px", marginTop: "-4px" }}
        />
        <div>({ratingCount !== undefined ? `${ratingCount}` : ""})</div>
      </div>
    );
  };

  const ImageAndNameRenderer = ({ data }) => (
    <div className="d-flex align-items-center">
      {/* {console.log("course array", data)} */}
      <div className="mt-2">
        <span
          style={{
            marginLeft: "8px",
            marginBottom: "-25px !important",
            display: "block",
          }}
        >
          {/* {data?.} */}
          <div className="d-flex">
            {data?.courses.map((cur, index) => (
              <div key={cur.courseSubjectName + index} className="mr-1">
                {cur.courseSubjectName} {""} ,{" "}
              </div>
            ))}
          </div>
        </span>
      </div>
    </div>
  );

  const subjectCellRenderer = ({ data }) => (
    <ImageAndNameRenderer data={data} />
  );

  const getRowHeight = (params) => {
    var Heights = [55, 55, 55, 55];
    return Heights[params.node.rowIndex % 4];
  };

  const gridOptions = {
    getRowHeight: getRowHeight,
  };

  const centerStyle = {
    display: "flex",
    alignItems: "center",
    fontSize: "14px",
  };

  const [rowData, setRowData] = useState([]);
  useEffect(() => {
    setLoading(true); // Start loading
    getTeachers()
      .then((response) => {
        // console.log("response", response?.data);
        // debugger;
        setRowData(response.data.data);
        setLoading(false); // Stop loading
      })
      .catch((error) => {
        console.error("Error fetching teachers:", error);
        setLoading(false); // Stop loading
      });
  }, []);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setShowDetailedCard(false);
  }, [location]);

  const navigateTo = (path) => {
    navigate(`/total-teachers/${path}`);
  };

  const currentSection =
    location.pathname.split("/").pop().toLowerCase() || "approved";

  const rowDataFiltered = Array.isArray(rowData)
    ? rowData.filter((item) => {
        if (!input) return true;
        return Object.keys(item).some((key) => {
          if (typeof item[key] === "string") {
            const s1 = (item[key] || "").toLowerCase();
            const s2 = (input || "").toLowerCase();
            return s1.includes(s2);
          }
          return false;
        });
      })
    : [];

  const approvedTeachers = rowDataFiltered.filter(
    (teacher) => teacher.approved
  );
  const pendingTeachers = rowDataFiltered.filter(
    (teacher) => !teacher.approved
  );

  const columnDefsPending = [
    {
      headerName: "Teacher",
      field: "fullName",
      flex: 1,
      cellStyle: centerStyle,
      filter: true,
    },
    {
      headerName: "Subject",
      field: "courses",
      flex: 1,
      filter: true,
      cellStyle: centerStyle,
      cellRenderer: (params) => {
        const courses = params.data?.courses || [];
        // Extract the courseSubjectName from each course object and join them with commas
        return courses.length > 0
          ? courses.map((course) => course.courseSubjectName).join(", ")
          : "N/A";
      },
    },
    {
      headerName: "Profile",
      field: "view",
      flex: 1,
      cellRenderer: viewCellRenderer,
      cellStyle: centerStyle,
    },
    {
      headerName: "Reviews",
      field: "ratingCount",
      flex: 1,
      cellRenderer: reviewCellRenderer,
      cellStyle: centerStyle,
    },
    {
      headerName: "Block",
      field: "isBlocked",
      flex: 1,
      cellRenderer: (param) => (
        <Chip
          label={param?.data?.isBlocked ? "Blocked" : "Open"}
          color={param?.data?.isBlocked ? "error" : "success"}
          size="small"
          sx={{ mr: 0.5, mb: 0.5 }}
        />
      ),
      cellStyle: centerStyle,
    },
    {
      headerName: "Action",
      field: "action",
      flex: 1,
      cellRenderer: actionCellRendererPending,
      cellStyle: centerStyle,
    },
  ];

  const columnDefsApproved = [
    {
      headerName: "Teacher",
      field: "fullName",
      flex: 1,
      cellStyle: centerStyle,
      filter: true,
    },
    {
      headerName: "Subject",
      field: "courses",
      flex: 1,
      filter: true,
      cellStyle: centerStyle,
      cellRenderer: (params) => {
        const courses = params.data?.courses || [];
        return courses.length > 0
          ? courses.map((course) => course.courseSubjectName).join(", ")
          : "N/A";
      },
    },
    {
      headerName: "Profile",
      field: "view",
      flex: 1,
      cellRenderer: viewCellRenderer,
      cellStyle: centerStyle,
    },
    {
      headerName: "Reviews",
      field: "ratingCount",
      flex: 1,
      cellRenderer: reviewCellRenderer,
      cellStyle: centerStyle,
    },
    {
      headerName: "Block",
      field: "isBlocked",
      flex: 1,
      cellRenderer: (param) => (
        <Chip
          label={param?.data?.isBlocked ? "Blocked" : "Open"}
          color={param?.data?.isBlocked ? "error" : "success"}
          size="small"
          sx={{ mr: 0.5, mb: 0.5 }}
        />
      ),
      cellStyle: centerStyle,
    },
    {
      headerName: "Action",
      field: "action",
      flex: 1,
      cellRenderer: actionCellRendererApproved,
      cellStyle: centerStyle,
    },
  ];

  const handleBlockedModalCancel = () => {
    setData(undefined);
    setIsBlockedModalVisible(false);
  };

  const handleBlockedModalOk = async () => {
    try {
      const response = await toggleBlockTeacher(
        data?.id,
        !data?.isBlocked,
        blockedMessage
      );
      if (response.status === 200) {
        toast.success(
          `Teacher ${!data?.isBlocked ? "blocked" : "unblocked"} successfully.`
        );
        console.log("Teacher blocked/unblocked successfully", response);
        setRowData((prevRowData) => {
          return prevRowData.map((teacher) => {
            if (teacher.id === data?.id) {
              return { ...teacher, isBlocked: !data?.isBlocked };
            }
            return teacher;
          });
        });
      } else {
        console.error(
          "Error blocking/unblocking teacher:",
          response.statusText
        );
        toast.error(
          `Failed to ${!data?.isBlocked ? "unblock" : "block"} teacher.`
        );
      }
    } catch (error) {
      console.error("Error blocking/unblocking teacher:", error);
      toast.error("An error occurred. Please try again.");
    }
    console.log("Data MOdal Blcked", data);
    handleBlockedModalCancel();
  };

  const renderModal = !!data;

  const handleApprovedModalCancel = () => {
    setData(undefined);
    setIsApprovedModalVisible(false);
  };

  const handleApprovedModalOk = async () => {
    try {
      const response = await approvedTeacher(data?.id, !data?.isApproved);
      if (response.status === 200) {
        toast.success(
          `Teacher ${
            !data?.isApproved ? "approved" : "unapproved"
          } successfully.`
        );
        console.log("Teacher approved/unapproved successfully", response);
        setRowData((prevRowData) => {
          return prevRowData.map((teacher) => {
            if (teacher.id === data?.id) {
              return { ...teacher, approved: !data?.isApproved };
            }
            return teacher;
          });
        });
      } else {
        console.error(
          "Error approving/unapproving teacher:",
          response.statusText
        );
      }
    } catch (error) {
      console.error("Error approving/unapproving teacher:", error);
      toast.error("An error occurred while processing the request.");
    }
    handleApprovedModalCancel();
  };

  const handleReviewModalCancel = () => {
    setData(undefined);
    setIsReviewsModalVisible(false);
  };

  // const handleReviewModalOk = async () => {
  //   alert();
  // };

  const filterTextBox = () => {
    console.log("Clicked Filter");
  };

  const handleOnChange = (e) => {
    setInput(e.target.value);
    console.log("Value Changed !", e.target.value);
  };

  return (
    <>
      <Layout>
        {currentSection === "pending" ? (
          <>
            <div className="d-flex flex-wrap justify-content-between align-items-end">
              <div className="text-left col-3">
                <h3 className="h3">Total Teacher</h3>
                <span className="fs_12">
                  Total Number of Teachers
                  <span className="fw-bold">
                    {" "}
                    "
                    {currentSection === "pending"
                      ? pendingTeachers.length
                      : approvedTeachers.length}
                    "
                  </span>
                </span>
              </div>
              <div className="text-center col-6">
                <form className="d-flex rounded mt-2" role="search">
                  <div
                    className={`d-flex rounded ${styles.searchBG_color} shadow-sm w-100`}
                  >
                    <input
                      type="search"
                      id="filterTextBox"
                      onClick={filterTextBox}
                      onChange={handleOnChange}
                      className={`form-control ${styles.fee_input} border-0 rounded form_control_focus_box_shadow_none ${styles.searchBG_color}`}
                      placeholder={"Search..."}
                      value={input}
                      aria-label="Username"
                      aria-describedby="basic-addon1"
                      style={{
                        color: "#000",
                        opacity: 1,
                        fontSize: "13px",
                        "::placeholder": {
                          color: "white",
                          fontSize: "12px",
                        },
                      }}
                    />
                    <AiOutlineSearch className={`${styles.searhIcon}`} />
                  </div>
                </form>
              </div>
              <div className="text-right col-3">
                <div
                  className="btn-group btn-sm m-0 p-0 text-right"
                  role="group"
                  aria-label="Basic example"
                >
                  <button
                    type="button"
                    onClick={() => navigateTo("pending")}
                    className={`btn btn-sm ${
                      currentSection === "pending"
                        ? "btn_contained_black text-white"
                        : "btn_outlined text-dark"
                    }`}
                  >
                    Pending
                  </button>
                  <button
                    type="button"
                    onClick={() => navigateTo("approved")}
                    className={`btn btn-sm ${
                      currentSection === "approved"
                        ? "btn_contained_black text-white"
                        : "btn_outlined text-dark"
                    }`}
                  >
                    Approved
                  </button>
                </div>
                {/* <div>
                  <form className="d-flex rounded mt-2" role="search">
                    <div
                      className={`d-flex rounded ${styles.searchBG_color} my-1 shadow-sm`}
                    >
                      <input
                        type="search"
                        id="filterTextBox"
                        onClick={filterTextBox}
                        onChange={handleOnChange}
                        className={`form-control ${styles.fee_input} border-0 rounded form_control_focus_box_shadow_none ${styles.searchBG_color}`}
                        placeholder={"Search..."}
                        value={input}
                        aria-label="Username"
                        aria-describedby="basic-addon1"
                        style={{
                          color: "#000",
                          opacity: 1,
                          fontSize: "13px",
                          "::placeholder": {
                            color: "white",
                            fontSize: "12px",
                          },
                        }}
                      />
                      <AiOutlineSearch className={`${styles.searhIcon}`} />
                    </div>
                  </form>
                </div> */}
              </div>
            </div>
          </>
        ) : currentSection === "approved" ? (
          <>
            <div className="d-flex flex-wrap justify-content-between align-items-end">
              <div className="text-left col-3">
                <h3 className="h3">Total Teacher</h3>
                <span className="fs_12">
                  Total Number of Teachers
                  <span className="fw-bold">
                    {" "}
                    "
                    {currentSection === "pending"
                      ? pendingTeachers.length
                      : approvedTeachers.length}
                    "
                  </span>
                </span>
              </div>
              <div className="text-center col-6">
                <form className="d-flex rounded mt-2" role="search">
                  <div
                    className={`d-flex rounded ${styles.searchBG_color} shadow-sm w-100`}
                  >
                    <input
                      type="search"
                      id="filterTextBox"
                      onClick={filterTextBox}
                      onChange={handleOnChange}
                      className={`form-control ${styles.fee_input} border-0 rounded form_control_focus_box_shadow_none ${styles.searchBG_color}`}
                      placeholder={"Search..."}
                      value={input}
                      aria-label="Username"
                      aria-describedby="basic-addon1"
                      style={{
                        color: "#000",
                        opacity: 1,
                        fontSize: "13px",
                        "::placeholder": {
                          color: "white",
                          fontSize: "12px",
                        },
                      }}
                    />
                    <AiOutlineSearch className={`${styles.searhIcon}`} />
                  </div>
                </form>
              </div>
              <div className="text-right col-3">
                <div
                  className="btn-group btn-sm m-0 p-0"
                  role="group"
                  aria-label="Basic example"
                >
                  <button
                    type="button"
                    onClick={() => navigateTo("pending")}
                    className={`btn btn-sm ${
                      currentSection === "pending"
                        ? "btn_contained_black text-white"
                        : "btn_outlined text-dark"
                    }`}
                  >
                    Pending
                  </button>
                  <button
                    type="button"
                    onClick={() => navigateTo("approved")}
                    className={`btn btn-sm ${
                      currentSection === "approved"
                        ? "btn_contained_black text-white"
                        : "btn_outlined text-dark"
                    }`}
                  >
                    Approved
                  </button>
                </div>
                {/* <div>
                  <form className="d-flex rounded mt-2" role="search">
                    <div
                      className={`d-flex rounded ${styles.searchBG_color} my-1 shadow-sm`}
                    >
                      <input
                        type="search"
                        id="filterTextBox"
                        onClick={filterTextBox}
                        onChange={handleOnChange}
                        className={`form-control ${styles.fee_input} border-0 rounded form_control_focus_box_shadow_none ${styles.searchBG_color}`}
                        placeholder={"Search..."}
                        value={input}
                        aria-label="Username"
                        aria-describedby="basic-addon1"
                        style={{
                          color: "#000",
                          opacity: 1,
                          fontSize: "13px",
                          "::placeholder": {
                            color: "white",
                            fontSize: "12px",
                          },
                        }}
                      />
                      <AiOutlineSearch className={`${styles.searhIcon}`} />
                    </div>
                  </form>
                </div> */}
              </div>
            </div>
          </>
        ) : (
          ""
        )}

        <div className="d-flex justify-content-between">
          <div
            className={`fs_14 pt-1 col-md-${
              showDetailedCard ? "7" : "12"
            } col-sm-12`}
          >
            {loading ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ height: "100vh" }}
              >
                <div>Loading...</div>
              </div>
            ) : currentSection === "pending" ? (
              <AdminGrid
                row={pendingTeachers}
                cols={columnDefsPending}
                rowClass={"fs_12"}
                gridOptions={gridOptions}
                style={{ height: "102%" }}
                pagination={true}
              />
            ) : currentSection === "approved" ? (
              <AdminGrid
                row={approvedTeachers}
                cols={columnDefsApproved}
                rowClass={"fs_12"}
                gridOptions={gridOptions}
                style={{ height: "102%" }}
                pagination={true}
              />
            ) : (
              <TeacherAllDetails data={cardData} />
            )}
          </div>
        </div>

        <ReviewsModal
          isReviewsModalVisible={isReviewsModalVisible}
          handleReviewsCancel={() => setIsReviewsModalVisible(false)}
          data={reviews}
        />

        <WarningModal
          data={data}
          isModalVisible={isWarningModalVisible}
          setIsModalVisible={setIsWarningModalVisible}
          role="teacher"
        />

        {renderModal && (
          <BlockedModal
            data={data}
            Message={blockedMessage}
            setMessage={setBlockedMessage}
            isBlockedModalVisible={isBlockedModalVisible}
            handleCancel={handleBlockedModalCancel}
            role="teacher"
            title="Block Teacher"
            handleOk={handleBlockedModalOk}
          />
        )}

        {renderModal && (
          <ApprovedModal
            data={data}
            isApprovedModalVisible={isApprovedModalVisible}
            handleApprovedCancel={handleApprovedModalCancel}
            role="teacher"
            title="Block Teacher"
            handleApprovedOk={handleApprovedModalOk}
          />
        )}

        {locationModal && teacherLocation && (
          <LocationModal
            isOpen={locationModal}
            onCancel={() => setLocationModal(false)}
            location={teacherLocation}
          />
        )}
      </Layout>
    </>
  );
}

export default TotalTeachers;
